module.exports = __webpack_public_path__ + "static/media/NxtPort-IC.3caa24c2.svg";